<template>
    <component ref="root" :is="componentType" v-bind="dataProps"></component>
</template>

<script lang="ts" setup>
import { computed, markRaw, ref, defineAsyncComponent } from "vue";
import { AppRootEnum } from "./app-root-enum";

const props = withDefaults(
    defineProps<{
        componentName: string;
        showLoader: boolean;
        dataProps: object;
        appRoot: AppRootEnum;
    }>(),
    {
        showLoader: true,
        isStandalone: false,
    }
);

const root = ref(null);

const componentDestinationPath = computed(() => {
    return props.componentName.substring(0, props.componentName.lastIndexOf("/"));
});

const componentName = computed(() => {
    return props.componentName.split("/").slice(-1)?.[0];
});

const getComponentPath = () => {
    switch (props.appRoot) {
        case AppRootEnum.standalone:
            return import(`../standalone-pages/${componentDestinationPath.value}/_${componentName.value}.vue`);
        case AppRootEnum.sharedComponents:
            return import(
                `../../../../libs/shared-components/${componentDestinationPath.value}/_${componentName.value}.vue`
            );
        default:
            return import(`../app/${componentDestinationPath.value}/_${componentName.value}.vue`);
    }
};

const componentType = markRaw(defineAsyncComponent(() => getComponentPath()));
</script>
